module.exports = __webpack_public_path__ + "static/media/icon-repas.8cbe2113.svg";